import { render, staticRenderFns } from "./contragent-menu.vue?vue&type=template&id=b9a30106"
import script from "./contragent-menu.vue?vue&type=script&lang=js"
export * from "./contragent-menu.vue?vue&type=script&lang=js"
import style0 from "./contragent-menu.vue?vue&type=style&index=0&id=b9a30106&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports